import BemIt, { addClass } from "@gtechdoodler/bem-it";

import { TypographyVariantOptions } from "../../typography/Typography/Typography.types";
import StyledLabel from "./Label.styles";
import { LabelProps } from "./Label.types";

const typographyVariantMapping = {
	sm: "body-small",
	md: "body",
	lg: "body-large",
};

const Label: React.FC<LabelProps> = ({
	size = "sm",
	bold = false,
	className,
	...props
}) => {
	const block = new BemIt("Label");

	return (
		<StyledLabel
			className={addClass(className).after(block)}
			variant={typographyVariantMapping[size] as TypographyVariantOptions}
			htmlTag="label"
			weight={bold ? "heaviest" : "regular"}
			colorContrast={3}
			{...props}
		/>
	);
};

export default Label;
